import axios from 'axios'
import {getApiUrls} from "@/http/base.http";

export function getArchivalHistory(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/history/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function deleteArchivalHistory(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/export/history/delete`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

